import { render, staticRenderFns } from "./MyTicketDetail.vue?vue&type=template&id=a7730ab6&scoped=true&"
import script from "./MyTicketDetail.vue?vue&type=script&lang=js&"
export * from "./MyTicketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7730ab6",
  null
  
)

export default component.exports